import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function Modules() {
  const tomos = [{
    num: '01',
    title: 'Fisiología del Cambio',
    desc: 'Zonas de entrenamiento con base real. Explicá el "por qué" y lográ que tus alumnos se comprometan el doble.'
  }, {
    num: '02',
    title: 'Biomecánica y Técnica',
    desc: 'Los 15 drills esenciales y el protocolo visual para corregir vicios técnicos desde la primera clase.'
  }, {
    num: '03',
    title: 'Planificación Maestra',
    desc: 'Macrociclos listos para 5k, 10k, 21k y maratón. Tu año entero deja de ser un misterio.'
  }, {
    num: '04',
    title: 'Evaluación y Seguimiento',
    desc: 'Tests de campo e informes mensuales. La herramienta de retención más poderosa que vas a tener.'
  }, {
    num: '05',
    title: 'Prevención y Readaptación',
    desc: 'Protocolos exactos para las lesiones más frecuentes. Nunca más te quedás sin respuesta.'
  }, {
    num: '06',
    title: 'El Negocio del Profe',
    desc: 'Posicionamiento, precios y el plan de 90 días para triplicar tu facturación sin trabajar más horas.'
  }];
  return <section className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-39">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-40">
        <FadeIn className="text-center mb-20" data-id="element-41">
          <h2 className="text-brand-volt font-bold tracking-widest text-sm mb-4" data-id="element-42">
            EL SISTEMA PRINCIPAL
          </h2>
          <h3 className="text-5xl sm:text-6xl font-black text-white" data-id="element-43">
            LOS 6 PILARES <br data-id="element-44" /> DE TU NUEVA ESTRUCTURA
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-45">
          {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-46">
              <div className="relative p-8 bg-brand-surface border border-brand-muted/20 hover:border-brand-volt transition-all group" data-id="element-47">
                <div className="absolute top-4 right-4 text-6xl font-black text-brand-dark/50 group-hover:text-brand-volt/10 transition-colors pointer-events-none" data-id="element-48">
                  {tomo.num}
                </div>
                <BookOpenIcon className="w-8 h-8 text-brand-volt mb-6" data-id="element-49" />
                <h4 className="text-2xl font-bold text-white mb-4 pr-8" data-id="element-50">
                  {tomo.title}
                </h4>
                <p className="text-gray-400 leading-relaxed normal-case" data-id="element-51">
                  {tomo.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}